<template src="./search-template.vue" />

<script>
import indexMixin from './index-mixin';

export default {
  name: 'SearchComponent',

  mixins: [indexMixin],

  data() {
    return {
      config: {
        type: 'companies',
        availableFilters: {
          jobType: false,
          jobRole: false,
          companyIndustry: true,
          ted: true,
          location: true,
        },
        sortFields: [
          {
            title: 'Most Relevant',
            value: 'most_relevant',
          },
        ],
      },
    };
  },
};
</script>
